import { render, staticRenderFns } from "./EMArticolo.vue?vue&type=template&id=0ddb42ce&scoped=true&"
import script from "./EMArticolo.vue?vue&type=script&lang=js&"
export * from "./EMArticolo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddb42ce",
  null
  
)

export default component.exports